import { render, staticRenderFns } from "./memberBasicTab.vue?vue&type=template&id=21476c42&scoped=true&"
import script from "./memberBasicTab.vue?vue&type=script&lang=js&"
export * from "./memberBasicTab.vue?vue&type=script&lang=js&"
import style0 from "./memberBasicTab.vue?vue&type=style&index=0&id=21476c42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21476c42",
  null
  
)

export default component.exports